<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { ExclamationCircleIcon, LinkIcon } from '@heroicons/vue/solid'
import LoadingSpinner from '../../base/LoadingSpinner.vue'
import MembershipDocument from './MembershipDocument.vue'
import { isCertificateEnabled } from '../../../utilities/usePlatformSettings'
import Certificates from './Certificates.vue'
const accountStateNatural = usePersonalAccountDataState()
const accountStateLegal = useLegalAccountDataState()
const account = ref(null)

onMounted(async () => {
    if (isNaturalProfile()) {
        account.value = accountStateNatural.naturalProfile
    } else {
        account.value = accountStateLegal.legalProfile
    }
})
</script>

<template>
    <div v-if="account" class="px-4 py-5 sm:px-6">
        <div v-if="account?.membership_document.length">
            <div class="mb-4 flex justify-start">
                <LinkIcon class="mr-2 h-6 w-6 text-gray-900" />
                <label class="mr-6">{{ $t('membership_management.membership_number') }}:</label>
                {{ account?.membership_number ?? '-' }}
            </div>
            <MembershipDocument />
        </div>
        <div v-else class="my-4">
            <div class="flex justify-center">
                <ExclamationCircleIcon class="h-24 w-24 text-gray-400" />
            </div>
            <h3 class="mt-8 text-center text-sm font-medium text-gray-900">
                {{ $t('membership_management.no_membership_number') }}
            </h3>
        </div>
        <Certificates v-if="isCertificateEnabled()" />
    </div>
    <div v-else>
        <LoadingSpinner class="h-10 w-10 fill-primary" />
    </div>
</template>

<style scoped></style>
